// src/utils/getWeightCategory.js

import {
  DISCIPLINES,
  isFemale,
  normalizeDiscipline,
  weightCategoriesByDiscipline,
} from "./categoryRules";

function getWeightCategory(
  gender,
  ageCategory,
  weight,
  cate_country = "France",
  discipline = DISCIPLINES.JUDO
) {
  const disciplineKey = normalizeDiscipline(discipline);

  const categoriesByCountry =
    weightCategoriesByDiscipline[disciplineKey] ||
    weightCategoriesByDiscipline[DISCIPLINES.JUDO];

  const weightCategories =
    categoriesByCountry[cate_country] || categoriesByCountry["France"] || {};

  const numericWeight = parseFloat(weight);

  if (
    weight === null ||
    weight === undefined ||
    weight === "" ||
    numericWeight === 0
  ) {
    return "Non pesé(e)";
  }

  if (Number.isNaN(numericWeight)) {
    return "Poids invalide";
  }

  if (!ageCategory || ageCategory === "Inconnu") {
    return "Catégorie d'âge inconnue";
  }

  // Cas particulier Judo uniquement
  if (
    disciplineKey === DISCIPLINES.JUDO &&
    ["Éveil", "Mini-Poussin(e)", "Poussin(e)", "U7", "U9"].includes(ageCategory)
  ) {
    return "GM";
  }

  const categoryKey = isFemale(gender) ? `${ageCategory}F` : ageCategory;

  if (!Object.prototype.hasOwnProperty.call(weightCategories, categoryKey)) {
    console.error(
      `Catégorie inconnue: ${categoryKey} pour la discipline ${disciplineKey}`
    );
    return "Catégorie inconnue";
  }

  const thresholds = weightCategories[categoryKey];
  const lastCategory = thresholds[thresholds.length - 1];

  if (numericWeight >= lastCategory) {
    return `+${lastCategory} kg`;
  }

  const selectedCategory = thresholds.find((cat) => numericWeight < cat);

  return selectedCategory == null
    ? "Aucune catégorie"
    : `-${selectedCategory} kg`;
}

export default getWeightCategory;